import type { SearchDeviceLogV2MutationRequestApi } from '@ingenico/api-sdk-device-management-private-v2';
import type { MapperOfStatus } from '@ingenico/react-ui';
import { DATAGRID_ROWS_PER_PAGE_OPTIONS } from '@ingenico/react-ui/datagrid';
import type { GridInitialState as GridInitialStatePro, GridSortModel } from '@mui/x-data-grid-pro';
import { DeviceLogStatus } from '../../model/deviceLogs.model';

export function getDeviceLogsMapperOfStatus(): MapperOfStatus {
  const statusMapper: MapperOfStatus = {
    [DeviceLogStatus.Failed]: {
      labelKey: 'deviceLogsModal.status.FAILED',
      status: 'error',
    },
    [DeviceLogStatus.InProgress]: {
      labelKey: 'deviceLogsModal.status.IN_PROGRESS',
      status: 'info',
    },
    [DeviceLogStatus.Canceled]: {
      labelKey: 'deviceLogsModal.status.CANCELED',
      status: 'error',
    },
    [DeviceLogStatus.Completed]: {
      labelKey: 'deviceLogsModal.status.COMPLETED',
      status: 'success',
    },
    [DeviceLogStatus.StopInProgress]: {
      labelKey: 'deviceLogsModal.status.STOP_IN_PROGRESS',
      status: 'warning',
    },
    DEFAULT: {
      labelKey: '',
      status: 'neutral',
    },
  };

  return statusMapper;
}

const fieldPrefix = `deviceLog`;

export const defaultDeviceLogsGridSortModel: GridSortModel = [
  {
    field: `startDate`,
    sort: 'desc',
  },
];

export const deviceLogsModalGridInitialState: GridInitialStatePro = {
  pagination: { paginationModel: { pageSize: DATAGRID_ROWS_PER_PAGE_OPTIONS[0], page: 0 } },
  sorting: {
    sortModel: defaultDeviceLogsGridSortModel,
  },
};

function getSortField(field: string): string {
  switch (field) {
    case 'duration': {
      return `${fieldPrefix}.requestedDuration`;
    }
    case 'types': {
      return `${fieldPrefix}.type`;
    }
    case 'id': {
      return `${fieldPrefix}.deviceLogId`;
    }
    case undefined: {
      //When no field is selected, the unsorted case, return the default startDate
      return `${fieldPrefix}.startDate`;
    }
    default: {
      return `${fieldPrefix}.${field}`;
    }
  }
}

export function transformDeviceLogsGridSort(gridSort: GridSortModel): SearchDeviceLogV2MutationRequestApi['sort'] {
  const [sortColumn] = gridSort;
  return {
    field: getSortField(sortColumn?.field),
    order: sortColumn?.sort === 'asc' ? 'ASC' : 'DESC',
  };
}

export function getDeviceLogsFilters(): SearchDeviceLogV2MutationRequestApi['filters'] {
  return [
    {
      filterType: 'array',
      name: `${fieldPrefix}.status`,
      operator: 'notExists',
      value: JSON.stringify(['CANCELED']),
    },
  ];
}
